// 渠道详情

import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ChannelState {
  channelCode: string;
  channelInfo: {
    isCreditSale: boolean;
  };
  setChannelCode: (channelCode: string) => void;
}

const useChannelStore = create<ChannelState>()(
  persist(
    (set) => ({
      channelCode: "",
      channelInfo: {
        isCreditSale: false, // 是否赊销
      },

      setChannelCode: (channelCode: string) => {
        set({ channelCode });

        let channelInfo = {
          isCreditSale: true,
        };

        // 特定渠道直接走赊销
        if (
          ["fJ3fOM"].includes(channelCode) // 测试环境
        ) {
          channelInfo.isCreditSale = false;
        }

        set({
          channelInfo,
        });
      },
    }),
    {
      name: "channel-storage", // unique name for localStorage key
    }
  )
);

export default useChannelStore;
